import Hero from '../sections/Hero'
import TrustBar from '../sections/TrustBar'
import ValuePillars from '../sections/ValuePillars'
import FeatureGrid from '../sections/FeatureGrid'
import AuthoritySection from '../sections/AuthoritySection'
import Testimonial from '../sections/Testimonial'
import Stats from '../sections/Stats'
import CTABand from '../sections/CTABand'

export default function Home() {
  return (
    <>
      <Hero />
      <TrustBar />
      <ValuePillars />
      <FeatureGrid />
      <AuthoritySection />
      <Testimonial />
      <Stats />
      <CTABand
        variant="dark"
        headline="See Klarhead WMS in action"
        description="Book a personalized demo and see how warehouse operations become clear, accurate, and audit-ready."
        secondaryCtaLink="/pricing/wms"
      />
    </>
  )
}
